export default __webpack_public_path__ + "static/media/trophy3.d32b6408.svg";